<template>
  <IonInput
    ref="inputRef"
    v-model="vModel"
    @ion-blur="onBlur"
    @ion-focus="onFocus"
    placeholder="Search"
    class="custom-search"
  >
    <i slot="start" :class="['icon-search text-2xl', isFocused ? 'text-blue-500' : 'text-gray-700']"></i>
  </IonInput>
</template>

<script setup lang="ts">
import { Keyboard, KeyboardResize } from '@capacitor/keyboard';
import { IonInput, isPlatform } from '@ionic/vue';
import { ref } from 'vue';

const inputRef = ref<InstanceType<typeof HTMLIonInputElement>>();
const vModel = defineModel({ type: String });
const isFocused = ref(false);
const oldKeyboardMode = ref<KeyboardResize>();

function clear() {
  vModel.value = undefined;
}

async function onBlur() {
  if (oldKeyboardMode.value && isPlatform('ios')) {
    await Keyboard.setResizeMode({ mode: oldKeyboardMode.value });
  }
  isFocused.value = false;
}

async function onFocus() {
  if (isPlatform('ios')) {
    try {
      oldKeyboardMode.value = (await Keyboard.getResizeMode()).mode;
      await Keyboard.setResizeMode({ mode: KeyboardResize.None });
    } catch (e) {
      console.log('Error getting/setting keyboard resize mode', e);
    }
  }
  isFocused.value = true;
}

defineExpose({
  isFocused,
  clear,
});
</script>

<style scoped>
ion-input.custom-search {
  --placeholder-color: #6b625e;
  --placeholder-opacity: 0.5;
  --color: #6b625e;
  font-weight: 400;
  font-size: 18px;
  --background: transparent;
}
</style>
